import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ToggleComponent } from './toggle/toggle.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-cookies-type',
    imports: [
        FormsModule,
        ReactiveFormsModule,
        ToggleComponent,
        TranslateModule
    ],
    templateUrl: './cookie-type.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CookieTypeComponent {
  @Input({ required: true }) public type: string;
  @Input({ required: true }) public title: string;
  @Input({ required: true }) public description: string;
  @Input({ required: true }) public control: FormControl;

}
